module.exports = __webpack_public_path__ + "img/tb-1.6f01b041.jpg";